module.exports = __webpack_public_path__ + "static/3-770cec20df86162841c2134c112613ba.jpg";